﻿import { isEmptyOrWhiteSpace } from "@tulipinfo/tue";
import { IBusinessResult } from "../interface/business-result";

export function getBusinessResultErrorMessage(br: IBusinessResult) {
    if (!isEmptyOrWhiteSpace(br.message)) {
        return br.message;
    }
    if (br.fieldErrors && br.fieldErrors.length > 0) {
        return br.fieldErrors[0].message;
    }

    return '';
}